import { render, staticRenderFns } from "./CollectionsIndex.vue?vue&type=template&id=36b3d7fc"
import script from "./CollectionsIndex.vue?vue&type=script&lang=js"
export * from "./CollectionsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports